import { inject, Injectable } from '@angular/core';
import { PermissionsService } from '@core/permissions/services/permissions.service';
import { CurrentUserService } from '@core/services/current-user.service';
import { TableSettingsService } from '@core/services/table-settings.service';
import { OidcSecurityService } from 'angular-auth-oidc-client';
import { firstValueFrom, forkJoin } from 'rxjs';

@Injectable({
  providedIn: 'root',
})
export class AuthService {
  private readonly _oidcSecurityService = inject(OidcSecurityService);
  private readonly _currentUserService = inject(CurrentUserService);
  private readonly _permissionsService = inject(PermissionsService);
  private readonly _tableSettingsService = inject(TableSettingsService);

  public async init(): Promise<boolean> {
    try {
      const { isAuthenticated, userData } = await firstValueFrom(this._oidcSecurityService.checkAuth());

      if (!isAuthenticated || !userData) {
        this._oidcSecurityService.authorize();
        return false;
      }

      await firstValueFrom(this._currentUserService.load());
      await firstValueFrom(forkJoin([this._permissionsService.load(), this._tableSettingsService.loadSettings()]));

      return true;
    } catch {
      this._oidcSecurityService.authorize();
      return false;
    }
  }

  public logout(): void {
    this._currentUserService.clear();
    this._permissionsService.clear();

    this._oidcSecurityService.logoff().subscribe();
  }
}
